class ReplaceStyleKeywords {
	/**
	 * Generalist/LMで定義されたキーワードをHTMLにリプレースする
	 * @param {string} keyword
	 */
	public replaceStyleKeywords(keyword: string) {
		if (!keyword) {
			return keyword;
		}
		return keyword.replace(
			/(@HtmlSize\[.*?\|)|(\]HtmlSize@)|(@HtmlColor\[.*?\|)|(\]HtmlColor@)|(@HtmlLink\[.*?\|)|(\]HtmlLink@)|(@HtmlBold\[)|(\]HtmlBold@)|(@HtmlItalic\[)|(\]HtmlItalic@)|(@HtmlUnderline\[)|(\]HtmlUnderline@)/g,
			(...args) => {
				// 「@HtmlSize[size|」を変換
				if (typeof args[1] !== 'undefined' && args[1].length >= 1) {
					const str = args[1].substring(10, args[1].indexOf('|', 10));
					return (
						"<span class='htmlKeyword' style='font-size:" +
						str +
						"; line-height: normal'>"
					);
				}
				// 「]HtmlSize@」を変換
				if (typeof args[2] !== 'undefined' && args[2].length >= 1) {
					return '</span>';
				}
				// 「@HtmlColor[color|」を変換
				if (typeof args[3] !== 'undefined' && args[3].length >= 1) {
					const str = args[3].substring(11, args[3].indexOf('|', 11));
					return (
						"<span class='htmlKeyword'  style='color:" + str + ";'>"
					);
				}
				// 「]HtmlColor@」を変換
				if (typeof args[4] !== 'undefined' && args[4].length >= 1) {
					return '</span>';
				}
				// 「@HtmlLink[url|」を変換
				if (typeof args[5] !== 'undefined' && args[5].length >= 1) {
					const str = args[5].substring(10, args[5].indexOf('|', 10));
					return (
						"<a href='javascript:void(0)' onclick='window.open(\"" +
						str +
						'")\'>'
					);
				}
				// 「]HtmlLink@」を変換
				if (typeof args[6] !== 'undefined' && args[6].length >= 1) {
					return '</a>';
				}
				// 「@HtmlBold[」を変換
				if (typeof args[7] !== 'undefined' && args[7].length >= 1) {
					return "<span class='htmlKeyword'  style='font-weight:bold;'>";
				}
				// 「]HtmlBold@」を変換
				if (typeof args[8] !== 'undefined' && args[8].length >= 1) {
					return '</span>';
				}
				// 「@HtmlItalic[」を変換
				if (typeof args[9] !== 'undefined' && args[9].length >= 1) {
					return "<span class='htmlKeyword'  style='font-style:italic;'>";
				}
				// 「]HtmlItalic@」を変換
				if (typeof args[10] !== 'undefined' && args[10].length >= 1) {
					return '</span>';
				}
				// 「@HtmlUnderline[」を変換
				if (typeof args[11] !== 'undefined' && args[11].length >= 1) {
					return "<span class='htmlKeyword'  style='text-decoration: underline'>";
				}
				// 「]HtmlUnderline@」を変換
				if (typeof args[12] !== 'undefined' && args[12].length >= 1) {
					return '</span>';
				}
				return '';
			}
		);
	}
}

export default new ReplaceStyleKeywords();



// WEBPACK FOOTER //
// ./src/utils/ReplaceStyleKeywords.ts